import { Drawer } from 'components/Drawer'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'
import { DrawerProps } from 'components/Drawer/Root'
import Styles from './NewValueDrawer.module.scss'
import { NewValueDialogProps } from 'blaze-ui/ArrayInput/Types'
import { Heading } from 'blaze-ui/Heading/Heading'

export interface Props {
  title: string
  placeholder: string
  onSubmit: (tag: string) => void
}

export const NewValueDrawer = ({ title, placeholder, onSubmit, ...props }: NewValueDialogProps & DrawerProps) => {
  const [newValue, setNewValue] = useState('')
  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5} lineClamp={1}>
                  {title}
                </Heading>
              </Drawer.Title>
              <Drawer.Close label="Cancel" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <div className={Styles.content}>
                <Input
                  autoFocus
                  size="lg"
                  name="value"
                  variant="grey"
                  placeholder={placeholder}
                  onChange={(e) => setNewValue(e.target.value)}
                  value={newValue}
                />
                <Button fullWidth onPress={() => onSubmit(newValue)} size="xl" variant="tertiary">
                  Submit
                </Button>
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
